import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface ActionMenuProps {
    params: any;
    onDelete: (data: any) => void;
}

const ActionMenu: React.FC<ActionMenuProps> = ({ params, onDelete }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event?: React.MouseEvent) => {
        if (event) {
            event.stopPropagation();
        }
        setAnchorEl(null);
    };

    const handleDelete = (event: React.MouseEvent) => {
        event.stopPropagation();
        onDelete(params.data);
        handleClose();
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <IconButton
                aria-label="more"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                size="small"
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        width: '15ch',
                        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                        borderRadius: '8px',
                    },
                }}
            >
                <MenuItem
                    onClick={handleDelete}
                    sx={{
                        fontSize: '13px',
                        color: 'error.main',
                        '&:hover': {
                            backgroundColor: 'error.lighter',
                        }
                    }}
                >
                    Delete
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ActionMenu;
